import { DisabledPrompt, useRoute } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import BaseToggleView from "components/shared/views/BaseToggleView";
import UIAmountInput from "components/ui/UIAmountInput";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import UINumberInput from "components/ui/UINumberInput";
import React, { useState } from "react";
import "./styles.css";

/**
 * @function EnableAdditionalAlertsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for EnableAdditionalAlertsPage
 */

export default function EnableAdditionalAlertsPage(props) {
  const navigate = useRoute();
  const cancelClick = evt => navigate(-1);

  const [ state, setState ] = useState({ dueAlert: false, creditAlert: false });
  const updateAlert = prop => value => setState({ ...state, [ prop ] : value });

  const showBtns = state.dueAlert || state.creditAlert;

  return(
    <MainContentContainer header={<MainContentHeader text="Enable Additional Alerts" icon="LeftChevronIcon" />} className="enable-additional-alerts-page">
      <FormContainer>
        <BaseToggleView 
          mainText="Payment Due Alert" 
          subText="Set number of days to be notified before your payment due date"
          onChange={ updateAlert("dueAlert") }
          checked={ state.dueAlert }
          toggleBlock ={
            <FormRow>
              <UINumberInput value="2" label="" />
            </FormRow>
          } />
          <BaseToggleView 
          mainText="Available Credit Alert" 
          subText="Get notified when your available credit goes below your chosen amount"
          onChange={ updateAlert("creditAlert") }
          checked={ state.creditAlert }
          toggleBlock ={
            <FormRow className="amount-input-form-row">
              <UIAmountInput value="100.00" />
            </FormRow>
          } />

          { showBtns &&
            <FormButtonContainer>
              <DisabledPrompt>
                <UIPrimaryButton text="Apply" />
              </DisabledPrompt>

              <UICancelButton text="Cancel" onClick={ cancelClick } />
            </FormButtonContainer> }
      </FormContainer>
    </MainContentContainer>
  );
}